import React from "react";

//navbar menu items
import NavbarData from "../navbar/NavbarData";

import { Flex, Text } from "@chakra-ui/react";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <Flex
      w={"100vw"}
      height={{ base: "auto", md: "8rem" }}
      py={{ base: "3rem", md: "" }}
      px={{ base: "2rem", "3sm": "5rem", lg: "" }}
      justifyContent={{ base: "space-between", lg: "space-evenly" }}
      alignItems={"center"}
      fontWeight={700}
      bg={"blackAlpha.900"}
      color={"whiteAlpha.900"}
      fontSize={{ base: "1.6rem", "3sm": "1.8rem" }}
      textTransform={"uppercase"}
      flexDir={{ base: "column", md: "row" }}
    >
      <Flex flexDir={{ base: "column", "2sm": "row" }} textAlign={"center"}>
        {NavbarData.map((item, index) => {
          return (
            <Link
              key={index}
              to={{ pathname: item.url }}
              state={{ id: item.id }}
            >
              <Text
                my={{ base: ".5rem", "3sm": "0" }}
                cursor={"pointer"}
                mx={{ base: ".5rem", "3sm": "2rem" }}
              >
                {item.name}
              </Text>
            </Link>
          );
        })}
      </Flex>
      <Text mt={{ base: "2rem", md: "0" }}>@ 2022 Akia Engineering, All Rights Reserved</Text>
    </Flex>
  );
};

export default Footer;
